import { render, staticRenderFns } from "./MachineTemplateDetailScreen.vue?vue&type=template&id=c6b0b4a6&scoped=true"
import script from "./MachineTemplateDetailScreen.vue?vue&type=script&lang=js"
export * from "./MachineTemplateDetailScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b0b4a6",
  null
  
)

export default component.exports